import React from 'react'
import './../App.css'
import X56Hull from './X56Hull'
import { Route, Switch, Redirect } from 'react-router-dom'
import X56BowSprit from './X56BowSprit'
import X56HullTreatment from './X56HullTreatment'
import X56Transom from './X56Transom'
import X56Deck from './X56Deck'
import X56Sprayhood from './X56Sprayhood'
import X56Wheel from './X56Wheel'
import X56Mast from './X56Mast'
import X56Interior from './X56Interior'
import X56Galley from './X56Galley'
import X56Fabric from './X56Fabric'
import X56Saloon from './X56Saloon'
import X56OwnersCabin from './X56OwnersCabin'
import X56AftCabin from './X56AftCabin'
import Logo from './x56-logo.svg'
import X56Summary from './X56Summary'
import X56BathingPlatform from './X56BathingPlatform'

import hullColor11 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x light grey RAL 7035 waterliness.jpg'
import hullColor12 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x black grey RAL 702 waterlines.jpg'
import hullColor14 from '../assets/hullColors/Hull colour - light grey RAL 7035 & 3 x pure white RAL 9010 waterlines.jpg'
import hullColor15 from '../assets/hullColors/Hull colour - black grey RAL 7021 & 3 x pure white RAL 9010 waterlines.jpg'

import fabric1 from '../assets/fabrics/JustFleckless–01Nature.jpg'
import fabric2 from '../assets/fabrics/JustFleckless–05Camel.jpg'
import fabric3 from '../assets/fabrics/JustFleckless–10Navy.jpg'
import fabric4 from '../assets/fabrics/JustFleckless–403Bambus.jpg'
import fabric5 from '../assets/fabrics/JustFleckless–710MoonGrey.jpg'
import fabric6 from '../assets/fabrics/JustFleckless–750OliveGrey.jpg'
import fabric7 from '../assets/fabrics/AlsaceBlue.jpg'
import fabric8 from '../assets/fabrics/AlsaceIvory.jpg'
import fabric9 from '../assets/fabrics/AlsaceSand.jpg'
import fabric10 from '../assets/fabrics/Nubilux709Argent.jpg'

import galley1 from '../assets/galleyColors/camoan_white_corian.jpg'
import galley2 from '../assets/galleyColors/black_quartz_corian.jpg'

import laminate1 from '../assets/interiorColors/teak_without_koto.jpg'
import laminate2 from '../assets/interiorColors/walnut.jpg'
import laminate3 from '../assets/interiorColors/teak_with_koto.jpg'

import sprayhood1 from '../assets/sprayhoodColors/without.jpg'
import sprayhood2 from '../assets/sprayhoodColors/Dark grey.jpg'
import sprayhood3 from '../assets/sprayhoodColors/Taupe.jpg'
import sprayhood4 from '../assets/sprayhoodColors/Captains blue.jpg'
import sprayhood5 from '../assets/sprayhoodColors/Silver grey.jpg'

import ConfiguratorContainer from '../ConfiguratorContainer'
import { withTranslation } from 'react-i18next'

class X56Container extends ConfiguratorContainer {
  constructor (props) {
    super(props)

    this.logo = Logo
    this.logoLink = 'https://www.x-yachts.com/en/yachts/x/x5-6/'

    this.HullColourOptions = [
      {
        value: 1,
        label: this.props.t('Pure White'),
        description: this.props.t(
          '(RAL 9010) & 3 x Light Grey (RAL 7035) integrated Gelcoat Water Lines'
        ),
        preview: hullColor11
      },
      {
        value: 2,
        label: this.props.t('Pure White'),
        description: this.props.t(
          '(RAL 9010) & 3 x Black Grey (RAL 7021) integrated Gelcoat Water Lines'
        ),
        preview: hullColor12
      },
      {
        value: 3,
        label: this.props.t('Light Grey'),
        description: this.props.t(
          '(RAL 7035) & 3 x Pure White (RAL 9010) integrated Gelcoat Water Lines'
        ),
        preview: hullColor14
      },
      {
        value: 4,
        label: this.props.t('Black Grey'),
        description: this.props.t(
          '(RAL 7021) & 3 x Pure White (RAL 9010) integrated Gelcoat Water Lines'
        ),
        preview: hullColor15
      }
    ]

    this.BowSpritOptions = [
      {
        value: 1,
        label: this.props.t('Standard'),
        description: this.props.t(
          'Carbon fibre bowsprit in hull colour painted carbon fibre for asymmetric spinnaker (accommodates the standard stainless steel anchor roller)'
        )
      },
      {
        value: 2,
        label: this.props.t('Optional'),
        description: this.props.t(
          'In clear coated carbon fibre for asymmetric spinnaker (accommodates the standard stainless steel anchor roller)'
        )
      }
    ]

    this.HullTreatmentOptions = [
      { value: 1, label: this.props.t('White') },
      { value: 2, label: this.props.t('Black') },
      { value: 3, label: this.props.t('Copper') }
    ]

    this.DeckOptions = [
      { value: 1, label: this.props.t('Genuine teak with black caulkings') },
      { value: 2, label: this.props.t('Flexiteek with grey stripes') }
    ]

    this.SprayhoodOptions = [
      { value: 1, label: this.props.t('Without'), thumbnail: sprayhood1 },
      { value: 2, label: this.props.t('Dark grey'), thumbnail: sprayhood2 },
      { value: 3, label: this.props.t('Taupe'), thumbnail: sprayhood3 },
      { value: 4, label: this.props.t('Captains blue'), thumbnail: sprayhood4 },
      { value: 5, label: this.props.t('Silver grey'), thumbnail: sprayhood5 }
    ]

    this.MastAndBoomOptions = [
      { value: 1, label: this.props.t('Aluminium') },
      { value: 2, label: this.props.t('White painted carbon') },
      { value: 3, label: this.props.t('Black painted carbon') },
      { value: 4, label: this.props.t('Clear coated carbon') }
    ]

    this.BoomCoverOptions = this.SprayhoodOptions

    this.WheelOptions = [
      {
        value: 1,
        label: this.props.t('Steel Wheel with leather covered rim'),
        description: this.props.t('(standard)')
      },
      { value: 2, label: this.props.t('Black Composite wheel') }
    ]

    this.DesignOptions = [
      { value: 1, label: this.props.t('Pacific - Nordic Oak') },
      { value: 2, label: this.props.t('Baltic - Nordic Oak') },
      { value: 3, label: this.props.t('Mediterranean - Nordic Oak') },
      { value: 4, label: this.props.t('Pacific - Modern Teak') },
      { value: 5, label: this.props.t('Baltic - Modern Teak') },
      { value: 6, label: this.props.t('Mediterranean - Modern Teak') }
    ]

    this.WorktopOptions = [
      {
        value: 1,
        label: this.props.t('Worktop in Camoan white Corian (standard)'),
        thumbnail: galley1
      },
      {
        value: 2,
        label: this.props.t('Worktop in black quartz Corian'),
        thumbnail: galley2
      }
    ]

    this.AftCabinLayoutOptions = [
      { value: 1, label: this.props.t('Double Berth') },
      { value: 2, label: this.props.t('Double Berth and Upper shelves') },
      {
        value: 3,
        label: this.props.t('Double Berth and Freeboard hung sea berths')
      },
      { value: 4, label: this.props.t('Double Berth and Upper cabinets') },
      { value: 5, label: this.props.t('Split Berth') },
      { value: 6, label: this.props.t('Split Berth and Upper shelves') },
      {
        value: 7,
        label: this.props.t('Split Berth and Freeboard hung sea berths')
      },
      { value: 8, label: this.props.t('Split Berth and Upper cabinets') }
    ]

    this.FabricOptions = [
      {
        value: 1,
        label: this.props.t('Just Fleckless – 01 Nature'),
        thumbnail: fabric1
      },
      {
        value: 2,
        label: this.props.t('Just Fleckless – 05 Camel'),
        thumbnail: fabric2
      },
      {
        value: 3,
        label: this.props.t('Just Fleckless – 10 Navy'),
        thumbnail: fabric3
      },
      {
        value: 4,
        label: this.props.t('Just Fleckless – 403 Bambus'),
        thumbnail: fabric4
      },
      {
        value: 5,
        label: this.props.t('Just Fleckless – 710 Moon Grey'),
        thumbnail: fabric5
      },
      {
        value: 6,
        label: this.props.t('Just Fleckless – 750 Olive Grey'),
        thumbnail: fabric6
      },
      { value: 7, label: this.props.t('Alsace Blue'), thumbnail: fabric7 },
      { value: 8, label: this.props.t('Alsace Ivory'), thumbnail: fabric8 },
      { value: 9, label: this.props.t('Alsace Sand'), thumbnail: fabric9 },
      {
        value: 10,
        label: this.props.t('Nubilux 709 Argent'),
        thumbnail: fabric10
      }
    ]

    this.GalleyLayoutOptions = [
      { value: 1, label: this.props.t('Open Galley') },
      { value: 2, label: this.props.t('Closed Galley') }
    ]

    this.LeatherHandlesOptions = [
      { value: 1, label: this.props.t('Off') },
      { value: 2, label: this.props.t('On') }
    ]

    this.SaloonTableOptions = [
      { value: 1, label: this.props.t('Table without table/drinks box below') },
      { value: 2, label: this.props.t('Luxury main cabin dining table') }
    ]

    this.HandrailOptions = [
      { value: 1, label: this.props.t('oak handrails') },
      { value: 2, label: this.props.t('teak handrails') },
      { value: 3, label: this.props.t('white tinted oak handrails') }
    ]

    this.BoomOptions = [
      { value: 1, label: this.props.t('O-Furling boom *') },
      { value: 2, label: this.props.t('V-furling boom *') },
      { value: 3, label: this.props.t('Carbon mast & boom *') },
      { value: 4, label: this.props.t('V-Carbon boom *') }
    ]

    this.FloorboardOptions = [
      {
        value: 1,
        label: this.props.t('Teak laminate (standard)'),
        thumbnail: laminate1
      },
      {
        value: 2,
        label: this.props.t('Walnut laminate (optional)'),
        thumbnail: laminate2
      },
      {
        value: 3,
        label: this.props.t('Teak with inlay stripes / holly (optional)'),
        thumbnail: laminate3
      }
    ]

    const defaultHullColour = this.HullColourOptions[0]
    const defaultTransomColor = this.getTransomColorByHullColourValue(
      defaultHullColour.value
    )

    this.state = Object.assign(this.state, {
      boat: 'X56',
      exterior: {
        HullColour: defaultHullColour,
        BowSprit: this.BowSpritOptions[0],
        HullTreatment: this.HullTreatmentOptions[0],
        Deck: this.DeckOptions[0],
        TeakOnSideDecks: { value: 2, label: 'true' },
        TeakOnCoachroof: { value: 2, label: 'true' },
        SprayHood: this.SprayhoodOptions[0],
        BiminiForHelmsman: { value: 1, label: 'false' },
        BiminiForForwardCockpit: { value: 1, label: 'false' },
        CockpitTent: { value: 1, label: 'false' },
        Wheel: this.WheelOptions[0],
        MastAndBoom: this.MastAndBoomOptions[0],
        BoomCover: this.BoomCoverOptions[0],
        LiftingArm: { value: 1, label: 'false' },
        Gangway: { value: 2, label: 'true' },
        AftBench: { value: 1, label: 'false' },
        SolarPanels: { value: 1, label: 'false' },
        WheelingSeats: { value: 1, label: 'false' },
        Boom: this.BoomOptions[0]
      },
      transom: {
        Name: {
          verticalOffset: 250,
          color: defaultTransomColor,
          value: 'My yacht',
          font: this.fontOptions[0],
          size: this.sizeOptions[2],
          horizontalOffset: 0
        },
        Port: {
          verticalOffset: 500,
          color: defaultTransomColor,
          value: 'Port',
          font: this.fontOptions[0],
          size: this.sizeOptions[1],
          horizontalOffset: 0
        }
      },
      interior: {
        Veneer: this.DesignOptions[1],
        Floorboard: this.FloorboardOptions[0],
        Handrail: this.HandrailOptions[0],
        Fabric: this.FabricOptions[0],
        GalleyLayout: this.GalleyLayoutOptions[0],
        Worktop: this.WorktopOptions[0],
        SaloonTableBox: this.SaloonTableOptions[0],
        SaloonPouffe: { value: 1, label: 'false' },
        SaloonBackRest: { value: 1, label: 'false' },
        CupboardsSaloon: { value: 1, label: 'false' },
        FabricOwnersCabin: this.FabricOptions[0],
        CupboardsOwnersCabin: { value: 1, label: 'false' },
        beautytable: { value: 1, label: 'false' },
        LargeWardrobe: { value: 1, label: 'false' },
        FabricAftCabin: this.FabricOptions[0],
        AftCabinLayout: this.AftCabinLayoutOptions[0],
        Mast: this.MastAndBoomOptions[0],
        LeatherHandles: { value: 1, label: 'false' }
      }
    })

    this.steps = [
      { name: this.props.t('Hull colourways'), url: '/x56/hull' },
      { name: this.props.t('Bowsprit'), url: '/x56/bowsprit' },
      { name: this.props.t('Hull treatment'), url: '/x56/hulltreatment' },
      { name: this.props.t('Deck'), url: '/x56/deck' },
      { name: this.props.t('Bathing platform'), url: '/x56/bathingplatform' },
      { name: this.props.t('Boat name'), url: '/x56/transom' },
      { name: this.props.t('Mast and boom'), url: '/x56/mast' },
      { name: this.props.t('Wheels'), url: '/x56/wheel' },
      { name: this.props.t('Sprayhood & Boom Cover'), url: '/x56/sprayhood' },

      { name: this.props.t('Interior surfaces'), url: '/x56/surfaces' },
      { name: this.props.t('Saloon furniture'), url: '/x56/saloon' },
      { name: this.props.t('Interior Fabric'), url: '/x56/fabric' },
      { name: this.props.t('Galley'), url: '/x56/galley' },
      { name: this.props.t("Owner's cabin"), url: '/x56/ownerscabin' },
      { name: this.props.t('Aft cabins'), url: '/x56/aftcabin' },

      { name: this.props.t('Summary'), url: '/x56/summary' }
    ]

    this.handleHullConfigurationChange =
      this.handleHullConfigurationChange.bind(this)
  }

  handleHullConfigurationChange (newConfiguration) {
    let transom = this.state.transom
    const transomColor = this.getTransomColorByHullColourValue(
      newConfiguration.HullColour.value
    )
    transom.Name.color = transomColor
    transom.Port.color = transomColor

    super.handleTransomChange(transom)
    super.handleExteriorConfigurationChange(newConfiguration)
  }

  getTransomColorByHullColourValue (hullColourValue) {
    switch (hullColourValue) {
      case 1:
        return this.colorOptions[6]
      case 2:
        return this.colorOptions[3]
      case 3:
      case 4:
        return this.colorOptions[1]
      default:
        return this.colorOptions[2]
    }
  }

  handleExteriorConfigurationChange (newConfiguration) {
    let interior = this.state.interior
    interior.Mast = newConfiguration.MastAndBoom

    super.handleInteriorConfigurationChange(interior)
    super.handleExteriorConfigurationChange(newConfiguration)
  }

  generateCode () {
    let data = []
    data.push('x56')

    data.push([])
    let exterior = this.state.exterior
    for (const key in exterior) {
      if (exterior.hasOwnProperty(key)) {
        let element = exterior[key].value
        data[data.length - 1].push(element)
      }
    }

    let transom = this.state.transom
    data.push([
      [
        transom.Name.value,
        transom.Name.font.value,
        transom.Name.size.value,
        transom.Name.color.value,
        transom.Name.horizontalOffset,
        transom.Name.verticalOffset
      ],
      [
        transom.Port.value,
        transom.Port.font.value,
        transom.Port.size.value,
        transom.Port.color.value,
        transom.Port.horizontalOffset,
        transom.Port.verticalOffset
      ]
    ])

    data.push([])
    let interior = this.state.interior
    for (const key in interior) {
      if (interior.hasOwnProperty(key)) {
        let element = interior[key].value
        data[data.length - 1].push(element)
      }
    }

    var json = JSON.stringify(data)
    return btoa(json)
  }

  parseCode (code) {
    let json = JSON.parse(atob(code))

    if (json[0] !== 'x56') {
      return
    }

    let exterior = this.state.exterior
    exterior.HullColour =
      this.HullColourOptions.find(v => v.value === json[1][0]) ||
      this.HullColourOptions[0]
    exterior.BowSprit =
      this.BowSpritOptions.find(v => v.value === json[1][1]) ||
      this.BowSpritOptions[0]
    exterior.HullTreatment =
      this.HullTreatmentOptions.find(v => v.value === json[1][2]) ||
      this.HullTreatmentOptions[0]
    exterior.Deck =
      this.DeckOptions.find(v => v.value === json[1][3]) || this.DeckOptions[0]
    exterior.TeakOnSideDecks = { value: +json[1][4] || 1, label: '' }
    exterior.TeakOnCoachroof = { value: +json[1][5] || 1, label: '' }
    exterior.SprayHood =
      this.SprayhoodOptions.find(v => v.value === json[1][6]) ||
      this.SprayhoodOptions[0]
    exterior.BiminiForHelmsman = { value: +json[1][7] || 1, label: '' }
    exterior.BiminiForForwardCockpit = { value: +json[1][8] || 1, label: '' }
    exterior.CockpitTent = { value: +json[1][9] || 1, label: '' }
    exterior.Wheel =
      this.WheelOptions.find(v => v.value === json[1][10]) ||
      this.WheelOptions[0]
    exterior.MastAndBoom =
      this.MastAndBoomOptions.find(v => v.value === json[1][11]) ||
      this.MastAndBoomOptions[0]
    exterior.BoomCover =
      this.BoomCoverOptions.find(v => v.value === json[1][12]) ||
      this.BoomCoverOptions[0]
    exterior.LiftingArm = { value: +json[1][13] || 1, label: '' }
    exterior.Gangway = { value: +json[1][14] || 1, label: '' }
    exterior.AftBench = { value: +json[1][15] || 1, label: '' }
    exterior.SolarPanels = { value: +json[1][16] || 1, label: '' }
    exterior.WheelingSeats = { value: +json[1][17] || 1, label: '' }
    exterior.Boom =
      this.BoomOptions.find(v => v.value === json[1][18]) || this.BoomOptions[0]

    let transom = this.state.transom
    transom.Name.value = json[2][0][0] || ''
    transom.Name.font =
      this.fontOptions.find(v => v.value === json[2][0][1]) ||
      this.fontOptions[0]
    transom.Name.size =
      this.sizeOptions.find(v => v.value === json[2][0][2]) ||
      this.sizeOptions[0]
    transom.Name.color =
      this.colorOptions.find(v => v.value === json[2][0][3]) ||
      this.colorOptions[0]
    transom.Name.horizontalOffset = +json[2][0][4] || 1
    transom.Name.verticalOffset = +json[2][0][5] || 1

    transom.Port.value = json[2][1][0] || ''
    transom.Port.font =
      this.fontOptions.find(v => v.value === json[2][1][1]) ||
      this.fontOptions[0]
    transom.Port.size =
      this.sizeOptions.find(v => v.value === json[2][1][2]) ||
      this.sizeOptions[0]
    transom.Port.color =
      this.colorOptions.find(v => v.value === json[2][1][3]) ||
      this.colorOptions[0]
    transom.Port.horizontalOffset = +json[2][1][4] || 1
    transom.Port.verticalOffset = +json[2][1][5] || 1

    let interior = this.state.interior
    interior.Veneer =
      this.VeneerOptions.find(v => v.value === json[3][0]) ||
      this.VeneerOptions[0]
    interior.Floorboard =
      this.FloorboardOptions.find(v => v.value === json[3][1]) ||
      this.FloorboardOptions[0]
    interior.Handrail =
      this.HandrailOptions.find(v => v.value === json[3][2]) ||
      this.HandrailOptions[0]
    interior.Worktop =
      this.WorktopOptions.find(v => v.value === json[3][3]) ||
      this.WorktopOptions[0]
    interior.Fabric =
      this.FabricOptions.find(v => v.value === json[3][4]) ||
      this.FabricOptions[0]
    interior.SaloonTable =
      this.SaloonTableOptions.find(v => v.value === json[3][5]) ||
      this.SaloonTableOptions[0]
    interior.SaloonPouffe = { value: +json[3][6] || 1, label: '' }
    interior.SaloonBackRest = { value: +json[3][7] || 1, label: '' }
    interior.CupboardsSaloon = { value: +json[3][8] || 1, label: '' }
    interior.FabricOwnersCabin =
      this.FabricOptions.find(v => v.value === json[3][9]) ||
      this.FabricOptions[0]
    interior.CupboardsOwnersCabin = { value: +json[3][10] || 1, label: '' }
    interior.beautytable = { value: +json[3][11] || 1, label: '' }
    interior.LargeWardrobe = { value: +json[3][12] || 1, label: '' }
    interior.FabricAftCabin =
      this.FabricOptions.find(v => v.value === json[3][13]) ||
      this.FabricOptions[0]
    interior.AftCabinLayout =
      this.AftCabinLayoutOptions.find(v => v.value === json[3][14]) ||
      this.AftCabinLayoutOptions[0]

    this.setState(this.state)
  }

  renderSteps () {
    return (
      <Switch location={this.props.location}>
        <Route exact path='/x56' render={() => <Redirect to='/x56/hull' />} />

        <Route
          path='/x56/hull'
          render={props => (
            <X56Hull
              {...props}
              onChange={this.handleHullConfigurationChange}
              onCodeSubmitted={this.parseCode}
              configuration={this.state.exterior}
              transom={this.state.transom}
              hullColourOptions={this.HullColourOptions}
            />
          )}
        />
        <Route
          path='/x56/bowsprit'
          render={props => (
            <X56BowSprit
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              bowSpritOptions={this.BowSpritOptions}
            />
          )}
        />
        <Route
          path='/x56/hulltreatment'
          render={props => (
            <X56HullTreatment
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              hullTreatmentOptions={this.HullTreatmentOptions}
            />
          )}
        />
        <Route
          path='/x56/transom'
          render={props => (
            <X56Transom
              {...props}
              onChange={this.handleTransomChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              fontOptions={this.fontOptions}
              sizeOptions={this.sizeOptions}
              colorOptions={this.colorOptions}
            />
          )}
        />
        <Route
          path='/x56/deck'
          render={props => (
            <X56Deck
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              deckOptions={this.DeckOptions}
            />
          )}
        />
        <Route
          path='/x56/bathingplatform'
          render={props => (
            <X56BathingPlatform
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
            />
          )}
        />
        <Route
          path='/x56/sprayhood'
          render={props => (
            <X56Sprayhood
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              sprayhoodOptions={this.SprayhoodOptions}
              boomCoverOptions={this.BoomCoverOptions}
            />
          )}
        />
        <Route
          path='/x56/wheel'
          render={props => (
            <X56Wheel
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              wheelOptions={this.WheelOptions}
            />
          )}
        />
        <Route
          path='/x56/mast'
          render={props => (
            <X56Mast
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              mastAndBoomOptions={this.MastAndBoomOptions}
              boomOptions={this.BoomOptions}
            />
          )}
        />

        <Route
          path='/x56/surfaces'
          render={props => (
            <X56Interior
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              designOptions={this.DesignOptions}
              handrailOptions={this.HandrailOptions}
              floorboardOptions={this.FloorboardOptions}
            />
          )}
        />
        <Route
          path='/x56/saloon'
          render={props => (
            <X56Saloon
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              tableOptions={this.SaloonTableOptions}
            />
          )}
        />
        <Route
          path='/x56/fabric'
          render={props => (
            <X56Fabric
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              layoutOptions={this.GalleyLayoutOptions}
              fabricOptions={this.FabricOptions}
            />
          )}
        />
        <Route
          path='/x56/galley'
          render={props => (
            <X56Galley
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              worktopOptions={this.WorktopOptions}
            />
          )}
        />
        <Route
          path='/x56/aftcabin'
          render={props => (
            <X56AftCabin
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              fabricOptions={this.FabricOptions}
              configuration={this.state.interior}
              aftCabinOptions={this.AftCabinLayoutOptions}
            />
          )}
        />
        <Route
          path='/x56/ownerscabin'
          render={props => (
            <X56OwnersCabin
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              fabricOptions={this.FabricOptions}
              configuration={this.state.interior}
            />
          )}
        />

        <Route
          path='/x56/summary'
          render={props => (
            <X56Summary
              {...props}
              country={this.state.country}
              countries={this.state.countries}
              code={this.generateCode()}
              configuration={{
                exterior: this.state.exterior,
                interior: this.state.interior,
                transom: this.state.transom
              }}
            />
          )}
        />
      </Switch>
    )
  }
}

export default withTranslation()(X56Container)



// WEBPACK FOOTER //
// ./src/X56/X56Container.js